<li>{{ data[key!] }}
    <a href="javascript:void(0)" class="select-btn" [class.selected]="selectedPillIds?.includes(data.id)"
        (click)="select(data)">
        {{ selectedPillIds?.includes(data.id) ? 'Đã chọn' : 'Chọn' }}
    </a>
    <a href="javascript:void(0)" *ngIf="data[subArrayKey!]?.length" class="right-arrow"
        (click)="onArrowClick($event, data)">
        <i class="ri-arrow-right-s-line"></i>
    </a>
</li>